export default "__VITE_ASSET__bxiRTGt4__"